import { FOCUS_TRAP_SELECTOR } from './constants'

interface HandleClickOutside {
  current?: HTMLDivElement | null
  event: MouseEvent
  onEscape(): void
}

const handleClickOutside = (
  { event, current, onEscape }: HandleClickOutside,
  name: string,
): void => {
  const dialogs = document.querySelectorAll(`${FOCUS_TRAP_SELECTOR}[data-modal-name=${name}]`)
  const isCurrentActiveDialog = dialogs[dialogs.length - 1] === current
  if (
    isCurrentActiveDialog &&
    event.target &&
    !dialogs[dialogs.length - 1].contains(event.target as Node)
  ) {
    onEscape()
  }
}

export default handleClickOutside
